// extracted by mini-css-extract-plugin
export default {"template":"Template-module__template__d7s9R","title":"Template-module__title__Xysi2","footer":"Template-module__footer__YmXxw"};